
import React, { Component } from 'react';
import TableFooter from '@material-ui/core/TableFooter';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Pagination from '@material-ui/lab/Pagination';
import {Button, Input} from '@material-ui/core';

import styled from 'styled-components';
import { SelectWidget } from 'form/Select';
import { ListContext } from './ListProvider';


const StyledTableFooter = styled(TableFooter)`
  background: #FBFBFB;
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 250px 1fr 250px;
  grid-gap: 10px;
  align-items: center;
  
  .pagination-container {
    display: grid;
    justify-items: center;
    overflow-x: auto;
  }
  
  .info-container {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
      
    .reset-btn {
        font-weight: normal;
        font-size: 12px;
    }
  }
  
  .reset-label-short {
    display: none;
  }
  
  .page-size {
    text-align: right;
  }
  
  @media (max-width: 767px) {
    grid-template-columns: auto 1fr auto;
    grid-template-areas:
      "range reset pagesize"
      "pagination pagination pagination";
    column-gap: 8px;
    row-gap: 8px;
    
    .info-container {
      display: contents;
    }
    
    .range {
      grid-area: range;
      align-self: center;
      white-space: nowrap;
    }
    
    .reset-btn {
      grid-area: reset;
      justify-self: center;
      align-self: center;
      min-width: 0;
      padding: 4px 8px;
    }
    
    .reset-label-full {
      display: none;
    }
    
    .reset-label-short {
      display: inline;
    }
    
    .pagination-container {
      grid-area: pagination;
      justify-items: center;
    }
    
    .page-size {
      grid-area: pagesize;
      text-align: right;
      align-self: center;
    }
  }
`;


export default class TableListFooter extends Component {

  static defaultProps = {
    showPerPageSelector: true
  };

  render() {
    const { colspan, showPerPageSelector } = this.props;
    return (
      <ListContext.Consumer>
        {context => {
          const { loading, pagination } = context;

          return (
            <StyledTableFooter>
              <TableRow>
                <TableCell colSpan={colspan}>
                  <Wrapper>
                    {pagination && (
                      <React.Fragment>
                        <div className={'info-container'}>
                          <span className={'range'}>
                            {(pagination.page * pagination.per_page - pagination.per_page) || 1}
                            <span> - </span>
                            {(pagination.page * pagination.per_page) > context.total ? context.total : pagination.page * pagination.per_page}
                            <span> из </span>
                            {context.total}
                          </span>

                          <Button className={'reset-btn'} onClick={() => context.setFilter({})}>
                            <span className={'reset-label-full'}>Сбросить фильтр</span>
                            <span className={'reset-label-short'}>Сбросить</span>
                          </Button>
                        </div>
                        <div className={'pagination-container'}>
                          <Pagination
                            count={pagination.total_pages}
                            disabled={loading}
                            onChange={(object, page) => context.setPageNumber(page)}
                          />
                        </div>
                        <div className={'page-size'}>
                          {showPerPageSelector && (
                            <SelectWidget
                              input={<Input disableUnderline={true} />}
                              value={pagination.per_page}
                              onChange={(value) => context.setFilterValue('page_size', value)}
                              options={[
                                {label: '15', value: 15},
                                {label: '30', value: 30},
                                {label: '50', value: 50},
                                {label: '100', value: 100},
                              ]}
                            />
                          )}
                        </div>
                      </React.Fragment>
                    )}
                  </Wrapper>
                </TableCell>
              </TableRow>
            </StyledTableFooter>
          )
        }}
      </ListContext.Consumer>
    )
  }
}
